import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import {
  CURRENT_PROPERTY_MANAGER_MAX,
  useFormController
} from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { BaseInput, InputSize } from "shared/components";

const NON_DIGIT_REGEX = /\D/g;

export const ProfileSection = ({
  form
}: {
  form: ReturnType<typeof useFormController>;
}) => {
  return (
    <SectionCard title="Profile">
      <div
        className="grid gap-4 w-full max-w-[752px]"
        style={{ gridTemplateColumns: "repeat(2,minmax(0,1fr))" }}
      >
        <div className="w-full">
          <BaseInput
            id="portfolioSize"
            size={InputSize.SM}
            label="Portfolio size"
            value={
              form.values.portfolio_size != null
                ? String(form.values.portfolio_size)
                : ""
            }
            error={form.errors.portfolio_size}
            onChange={form.handleChange("portfolio_size", (raw) => {
              const digits = String(raw ?? "").replace(NON_DIGIT_REGEX, "");
              return digits === "" ? null : Number(digits);
            })}
          />
        </div>
        <div className="w-full">
          <BaseInput
            id="currentPropertyManager"
            size={InputSize.SM}
            label="Current property manager"
            maxLength={CURRENT_PROPERTY_MANAGER_MAX}
            value={form.values.current_property_manager ?? ""}
            error={form.errors.current_property_manager}
            onChange={form.handleChange("current_property_manager")}
          />
        </div>
      </div>
    </SectionCard>
  );
};
